import HarperLoadingSpinner from "#/components/shared/HarperLoadingSpinner";
import Typography from "#/components/shared/typography";
import { useUserDetails } from "#/hooks/useUserDetails";

type AdminTemplatesGateProps = {
  children: React.ReactNode;
};

export function AdminTemplatesGate({ children }: AdminTemplatesGateProps) {
  const { userDetails, isLoading, error } = useUserDetails();
  const isAdmin = userDetails?.type === "admin";

  if (isLoading) {
    return (
      <div className="flex min-h-[40vh] items-center justify-center">
        <HarperLoadingSpinner />
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex flex-col items-center justify-center gap-3 min-h-[40vh]">
        <Typography variant="h4" className="text-terracotta">
          Unable to verify your permissions
        </Typography>
        <Typography variant="body1" className="text-brown-700">
          {error instanceof Error ? error.message : "Please try again later."}
        </Typography>
      </div>
    );
  }

  if (!isAdmin) {
    return (
      <div className="flex flex-col items-center justify-center gap-2 min-h-[40vh]">
        <Typography variant="h4" className="text-terracotta">
          403: Admin access required
        </Typography>
        <Typography variant="body2" className="text-terracotta/80">
          You must be an administrator to view message templates.
        </Typography>
      </div>
    );
  }

  return <>{children}</>;
}

export default AdminTemplatesGate;
